module.exports = __webpack_public_path__ + "static/media/congrats.6d833520.png";